import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import styles from "./styles.scss";

function CreationDate({ date }: Props) {
  const { t } = useTranslation();

  return (
    <p className={styles.date}>
      {new Date(date).toLocaleDateString()} {t("notifications.at")}{" "}
      {new Date(date).toLocaleTimeString()}
    </p>
  );
}

export { CreationDate };
